// A Nexus link request arriving at /link/nexus?code=…&nexus=…&profile=…
//
// Same constraint as share links (see utils/shareLinks): a Google sign-in round
// trip loses the URL, so the request is captured once at startup — before
// AuthContext rewrites history — and parked in storage until NexusLinkDialog
// deals with it. The code is single-use and short-lived on the Nexus side, so
// it is kept for 15 minutes at most here too.

const KEY = "pending_nexus_link";
const TTL_MS = 15 * 60 * 1000;

export function captureNexusLink(loc = window.location) {
  if (loc.pathname.replace(/\/+$/, "") !== "/link/nexus") return;
  const params = new URLSearchParams(loc.search || "");
  const code = params.get("code");
  const nexus = params.get("nexus");
  if (code && nexus) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ code, nexus, profile: params.get("profile") || "", at: Date.now() }));
    } catch {
      /* private mode: the dialog simply won't appear */
    }
  }
  // Never leave the code sitting in the address bar or in history.
  window.history.replaceState(null, "", "/");
}

export function getPendingNexusLink() {
  try {
    const item = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!item || Date.now() - item.at > TTL_MS) return null;
    return item;
  } catch {
    return null;
  }
}

export function clearPendingNexusLink() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
